/**
 * Size guide page: picking the child's age highlights the matching row in the size table and shows
 * the recommended size.
 */
class EbSizeGuide extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort.abort();
    this.#abort = new AbortController();
  }

  /** @param {MouseEvent} event */
  #onClick(event) {
    const button = event.target instanceof Element ? event.target.closest('[data-find-size]') : null;
    if (!(button instanceof HTMLElement)) return;
    const size = button.dataset.findSize || '';
    this.querySelectorAll('[data-find-size]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    this.querySelectorAll('.eb-size-table tbody tr').forEach((row) => {
      row.classList.toggle('is-match', row.getAttribute('data-size') === size);
    });
    const result = this.querySelector('[data-finder-result]');
    const text = this.querySelector('[data-finder-text]');
    if (result instanceof HTMLElement) result.hidden = false;
    if (text instanceof HTMLElement) {
      const [before = '', after = ''] = (text.dataset.template || '').split('[size]');
      const strong = document.createElement('strong');
      strong.textContent = size;
      text.replaceChildren(before, strong, after);
    }
  }
}

if (!customElements.get('eb-size-guide')) customElements.define('eb-size-guide', EbSizeGuide);
